<template>
  <div class="page page-be-accountable">

    <div class="hero be-accountable-hero no-hero-img">

      <div class="hero-content middle">
        <h1 class="page-title">
          Be Accountable
          <small>Consistency is key</small>
        </h1>
      </div>

      <div class="wave-bottom">
        <svg preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="100%" height="140px" viewBox="20 -20 300 100" xml:space="preserve">
          <path class="fill-primary" opacity=".075" d="M30.913,43.944c0,0,42.911-34.464,87.51-14.191c77.31,35.14,113.304-1.952,146.638-4.729 c48.654-4.056,69.94,16.218,69.94,16.218v54.396H30.913V43.944z"></path>
          <path class="fill-primary" opacity=".075" d="M-35.667,44.628c0,0,42.91-34.463,87.51-14.191c77.31,35.141,113.304-1.952,146.639-4.729 c48.653-4.055,69.939,16.218,69.939,16.218v54.396H-35.667V44.628z"></path>
          <path class="fill-primary" opacity="0" d="M43.415,98.342c0,0,48.283-68.927,109.133-68.927c65.886,0,97.983,67.914,97.983,67.914v3.716 H42.401L43.415,98.342z"></path>
          <path class="fill-white" d="M-34.667,62.998c0,0,56-45.667,120.316-27.839C167.484,57.842,197,41.332,232.286,30.428 c53.07-16.399,104.047,36.903,104.047,36.903l1.333,36.667l-372-2.954L-34.667,62.998z"></path>
        </svg>
      </div>

    </div>

    <div class="be-accountable-content">

      <div class="container">
        <p class="lead">Our bodies are not Amazon Prime and results will not show up in 2 days!</p>
        <div class="fc-alternate">

          <div class="fc-row">
            <div class="fc-img">
              <img src="../assets/img/thumb/cabbage-soup.jpg" alt="" />
            </div>
            <div class="fc-content">
              <div class="fc-content-inner">
                  <p>In a world where immediate gratification seems to rule our lives, and nearly everything is a click of a button away...accepting the truth about real physical change can be brutal.</p>
                  <p>You can argue this and show me proof that the cabbage soup diet got you to your goal in 5 days...or that crash dieting by pulling carbs and running endless sprints for a week helped you get in shape.</p>
              </div>
            </div>
          </div>

          <div class="fc-row">
            <div class="fc-img">
              <img src="../assets/img/thumb/salad-waist-measure.jpg" alt="" />
            </div>
            <div class="fc-content">
              <div class="fc-content-inner">
                  <p>But...did it stick?</p>
                  <p>Real <strong>CHANGE</strong> happens in slow motion, through consistency over time...plain and simple. The harder and faster you try to force change, the more your body and mind will fight it.</p>
              </div>
            </div>
          </div>

          <div class="fc-row">
            <div class="fc-img">
              <img src="../assets/img/thumb/sunset-road.jpg" alt="" />
            </div>
            <div class="fc-content">
              <div class="fc-content-inner">
                  <p>That’s where I can help!</p>
                  <p>I will help you create and follow a realistic plan. You must trust the process, <strong>BE PATIENT</strong> and stay the course. Your body will show up when it’s ready...most likely once you start loving it.</p>
              </div>
            </div>
          </div>

        </div>
      </div>

      <!-- Accountability Program -->
      <AccountabilityProgram />

      <!-- Services -->
      <Services />

    </div>

  </div>
</template>

<script>
import Services from '@/components/Services'
import AccountabilityProgram from '@/components/AccountabilityProgram'

export default {
  components: {
    Services,
    AccountabilityProgram
  },

  created () {
    this.$emit('ready')
  }
}
</script>

<style lang="scss">
@import '../assets/scss/beach-built/imports';

.be-accountable-hero {
  margin-bottom: 20px;
  // background: $bb-blue-lightest url('../assets/svg/alyssa.svg') repeat 0 0;
  // background-size: (144px * 2.5) (138px * 2.5);

  .wave-bottom {
    position: absolute;
    right: 0;
    left: 0;
    bottom: -20px;
  }

  @include media-breakpoint-up(md) {
    margin-bottom: 40px;
  }
}

.be-accountable-content {
  p {
    &.lead {
      text-align: center;

      &:first-child {
        max-width: 400px;
        margin: 0 auto 3rem auto;
      }
    }
  }
  .fc-alternate {
    margin-bottom: 4rem;
  }
}
</style>
